import './index.less';
import Invite from './Invite';
Invite.install = function(Vue) {
  Vue.component(Invite.name, Invite);
};

export default Invite;
